module.exports = __webpack_public_path__ + "img/1-low.6d14a57f.jpg";